import React from 'react';

import { Container } from './styles';

export default () => {
  return (
    <Container>
      <h1>pipefy</h1>
    </Container>
  );
};
